import { Link, useLocation } from "react-router-dom"
import { useEffect } from "react"
import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import QuizCard from "../components/QuizCard"
import HowItWorks from "../components/HowItWorks"
import WhySection from "../components/WhySection"
import Footer from "../components/Footer"
import { featuredQuizzes, cpcQuizzes, crcQuizzes, quizzesSection } from "../content/quizzes"
import { sampleCTA } from "../content/homepage"
import useIsMobile from "../hooks/useIsMobile"

const BUNDLE_URL     = "https://buy.stripe.com/9B68wReFm0Roeabf4d33W0i"
const CRC_BUNDLE_URL = "https://buy.stripe.com/8x26oJ40I7fM9TV4pz33W07"

export default function Home() {
    const isMobile = useIsMobile()
    const location = useLocation()

    useEffect(() => {
        const target = location.state && location.state.scrollTo
        if (target) {
            setTimeout(() => {
                document.getElementById(target)?.scrollIntoView({ behavior: "smooth" })
            }, 100)
        }
    }, [location.state])

    return (
        <div style={{ width: "100%", background: "white", fontFamily: "Inter, sans-serif", color: "#111827" }}>
            <Navbar />
            <Hero />
            <WhySection />

            {/* SECTION NAV */}
            <div id="section-nav" style={{
                position: "sticky", top: 0, zIndex: 100,
                background: "white",
                borderBottom: "1px solid #E5E7EB",
                boxShadow: "0 1px 6px rgba(17,24,39,0.06)",
            }}>
                <div style={{
                    maxWidth: 1280, margin: "0 auto",
                    padding: isMobile ? "10px 20px" : "12px 24px",
                    display: "flex", gap: isMobile ? 8 : 12,
                    justifyContent: "center",
                    overflowX: "auto",
                }}>
                    {[
                        { label: "Free Samples", id: "quizzes",  color: "#166534", bg: "#DCFCE7", hover: "#BBF7D0" },
                        { label: "CPC Quizzes",  id: "cpc",      color: "#6D28D9", bg: "#F5F3FF", hover: "#EDE9FE" },
                        { label: "CRC Quizzes",  id: "crc-exam", color: "#0F766E", bg: "#CCFBF1", hover: "#99F6E4" },
                    ].map(({ label, id, color, bg, hover }) => (
                        <button
                            key={id}
                            onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                            style={{
                                background: bg, border: "none", cursor: "pointer",
                                fontFamily: "inherit", fontWeight: 700,
                                fontSize: isMobile ? 13 : 14,
                                color: color,
                                padding: isMobile ? "8px 16px" : "9px 20px",
                                borderRadius: 20,
                                whiteSpace: "nowrap",
                                transition: "background 0.15s",
                            }}
                            onMouseEnter={e => { e.currentTarget.style.background = hover }}
                            onMouseLeave={e => { e.currentTarget.style.background = bg }}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            </div>

            {/* QUIZZES */}
            <section id="quizzes" style={{ maxWidth: 1280, margin: "0 auto", padding: isMobile ? "32px 20px 64px" : "40px 24px 100px" }}>
                <h2 style={{ fontSize: isMobile ? 32 : 56, marginBottom: 12, letterSpacing: "-0.04em" }}>
                    {quizzesSection.heading}
                </h2>
                <p style={{ fontSize: isMobile ? 17 : 20, color: "#6B7280", marginBottom: isMobile ? 32 : 48 }}>
                    {quizzesSection.subheading}
                </p>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24 }}>
                    {featuredQuizzes.map((quiz) => (
                        <QuizCard key={quiz.id} quiz={quiz} />
                    ))}
                </div>
            </section>

            {/* CPC QUIZZES */}
            <section id="cpc" style={{ background: "#F9FAFB", padding: isMobile ? "48px 20px 64px" : "64px 24px 100px" }}>
                <div style={{ maxWidth: 1280, margin: "0 auto" }}>
                    <div style={{ display: "inline-block", background: "#FDF4FF", color: "#7C3AED", borderRadius: 8, padding: "4px 14px", fontSize: 13, fontWeight: 700, marginBottom: 16 }}>
                        Medical Coding Diagnostics
                    </div>
                    <h2 style={{ fontSize: isMobile ? 28 : 48, marginBottom: 12, letterSpacing: "-0.04em" }}>
                        Medical Billing & Coding
                    </h2>
                    <p style={{ fontSize: isMobile ? 16 : 20, color: "#6B7280", marginBottom: isMobile ? 32 : 48 }}>
                        Practice CPC-style medical coding questions. Target weak areas by topic. Buy once — access yours forever.
                    </p>

                    {/* BUNDLE BANNER */}
                    <div style={{
                        background: "linear-gradient(135deg, #6D28D9 0%, #4C1D95 100%)",
                        borderRadius: 20,
                        padding: isMobile ? "28px 24px" : "32px 40px",
                        marginBottom: 32,
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "flex-start" : "center",
                        justifyContent: "space-between",
                        gap: 24,
                    }}>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
                                <span style={{ background: "#A78BFA", color: "white", borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>
                                    BEST VALUE
                                </span>
                                <span style={{ background: "#FCD34D", color: "#78350F", borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>
                                    LIMITED TIME
                                </span>
                                <span style={{ color: "#C4B5FD", fontSize: 13, fontWeight: 500 }}>Save $61 — limited time</span>
                            </div>
                            <h3 style={{ color: "white", fontSize: isMobile ? 20 : 24, margin: "0 0 6px", fontWeight: 700 }}>
                                Complete CPC Bundle — All 10 Quizzes
                            </h3>
                            <p style={{ color: "#C4B5FD", fontSize: 14, margin: "0 0 4px" }}>
                                Terminology · ICD-10-CM · E&M · Surgery · HCPCS · Compliance · Anesthesia · Radiology · Pathology & Lab · Medicine
                            </p>
                            <p style={{ color: "#A78BFA", fontSize: 13, margin: 0 }}>
                                Buy once — permanent access, no expiry
                            </p>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 16, flexShrink: 0 }}>
                            <div style={{ textAlign: "right" }}>
                                <div style={{ color: "#A78BFA", fontSize: 13, textDecoration: "line-through" }}>$59</div>
                                <div style={{ color: "white", fontSize: 28, fontWeight: 800, lineHeight: 1 }}>$29</div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                                <a
                                    href={BUNDLE_URL || "#"}
                                    style={{
                                        background: "white",
                                        color: "#6D28D9",
                                        padding: "14px 24px",
                                        borderRadius: 12,
                                        textDecoration: "none",
                                        fontWeight: 700,
                                        fontSize: 15,
                                        whiteSpace: "nowrap",
                                        opacity: BUNDLE_URL ? 1 : 0.6,
                                        cursor: BUNDLE_URL ? "pointer" : "not-allowed",
                                    }}
                                    onClick={e => { if (!BUNDLE_URL) e.preventDefault() }}
                                >
                                    Get Bundle →
                                </a>
                                <span style={{ color: "#C4B5FD", fontSize: 12, textAlign: "center" }}>
                                    Access code sent to your email instantly
                                </span>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 24 }}>
                        {cpcQuizzes.map((quiz) => (
                            <QuizCard key={quiz.id} quiz={quiz} />
                        ))}
                    </div>
                </div>
            </section>

            {/* CRC QUIZZES */}
            <section id="crc-exam" style={{ background: "#F0FDFA", padding: isMobile ? "48px 20px 64px" : "64px 24px 100px" }}>
                <div style={{ maxWidth: 1280, margin: "0 auto" }}>
                    <div style={{ display: "inline-block", background: "#CCFBF1", color: "#0D9488", borderRadius: 8, padding: "4px 14px", fontSize: 13, fontWeight: 700, marginBottom: 16 }}>
                        CRC Exam Prep
                    </div>
                    <h2 style={{ fontSize: isMobile ? 28 : 48, marginBottom: 12, letterSpacing: "-0.04em" }}>
                        Certified Risk Adjustment Coder
                    </h2>
                    <p style={{ fontSize: isMobile ? 16 : 20, color: "#6B7280", marginBottom: isMobile ? 32 : 48 }}>
                        HCC coding, RAF scoring, RADV compliance, and CMS-HCC model mastery — from beginner to advanced.
                    </p>

                    {/* CRC BUNDLE BANNER */}
                    <div style={{
                        background: "linear-gradient(135deg, #0F766E 0%, #134E4A 100%)",
                        borderRadius: 20,
                        padding: isMobile ? "28px 24px" : "32px 40px",
                        marginBottom: 32,
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "flex-start" : "center",
                        justifyContent: "space-between",
                        gap: 24,
                    }}>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                                <span style={{ background: "#14B8A6", color: "white", borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>
                                    BEST VALUE
                                </span>
                                <span style={{ color: "#99F6E4", fontSize: 13, fontWeight: 500 }}>Save $8</span>
                            </div>
                            <h3 style={{ color: "white", fontSize: isMobile ? 20 : 24, margin: "0 0 6px", fontWeight: 700 }}>
                                Complete CRC Bundle — All 3 Quizzes
                            </h3>
                            <p style={{ color: "#99F6E4", fontSize: 14, margin: "0 0 4px" }}>
                                Fundamentals · HCC Coding & RAF Scoring · Compliance & Auditing
                            </p>
                            <p style={{ color: "#5EEAD4", fontSize: 13, margin: 0 }}>
                                Buy once — permanent access, no expiry
                            </p>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 16, flexShrink: 0 }}>
                            <div style={{ textAlign: "right" }}>
                                <div style={{ color: "#5EEAD4", fontSize: 13, textDecoration: "line-through" }}>$27</div>
                                <div style={{ color: "white", fontSize: 28, fontWeight: 800, lineHeight: 1 }}>$19</div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                                <a
                                    href={CRC_BUNDLE_URL || "#"}
                                    style={{
                                        background: "white",
                                        color: "#0F766E",
                                        padding: "14px 24px",
                                        borderRadius: 12,
                                        textDecoration: "none",
                                        fontWeight: 700,
                                        fontSize: 15,
                                        whiteSpace: "nowrap",
                                        opacity: CRC_BUNDLE_URL ? 1 : 0.6,
                                        cursor: CRC_BUNDLE_URL ? "pointer" : "not-allowed",
                                    }}
                                    onClick={e => { if (!CRC_BUNDLE_URL) e.preventDefault() }}
                                >
                                    Get Bundle →
                                </a>
                                <span style={{ color: "#99F6E4", fontSize: 12, textAlign: "center" }}>
                                    Access code sent to your email instantly
                                </span>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 24 }}>
                        {crcQuizzes.map((quiz) => (
                            <QuizCard key={quiz.id} quiz={quiz} />
                        ))}
                    </div>
                </div>
            </section>

            <HowItWorks />

            <Footer />
        </div>
    )
}
